module.exports = __webpack_public_path__ + "img/image_1.be8571a7.png";